var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcNotice = function SvgIcNotice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 6h2.9c.3 0 .6.3.5.7-1 2.9-1 7.8 0 10.7.1.3-.2.6-.5.6H2.4c-.3 0-.5 0-.5-.1C.6 16.7 0 14.4 0 12c0-2.4.6-4.7 1.8-5.9.1 0 .3-.1.4-.1zM24 12c0 8-3.1 12.9-6.1 11.9-.8-.3-9.5-5.5-9.6-5.6-2-2.2-2-10.3 0-12.5.1-.1 9.2-5.5 9.5-5.6C20.6-.9 24 4 24 12zm-3.4-7.7c-1.1-2.3-3-2.2-4 0-.6 1.3-1 3.1-1.2 4.8h.3c1.6 0 3 1.2 3.1 2.7.1 1.6-1.2 3-2.9 3h-.5c.2 1.6.6 3.5 1.2 4.9 1 2.3 3.1 2.2 4 0 2-4.4 1.8-11.6 0-15.4zM7.4 24h-3c-.1 0-.2-.1-.2-.2l-1.5-4c-.1-.2.1-.3.2-.3h3c.1 0 .2.1.2.2l1.5 4c.1.1 0 .3-.2.3z"
  })));
};
export default SvgIcNotice;